export enum FileTypeEnum {
  Logo = 'logo',
  CalculationPhotos = 'calculationPhotos',
}
